var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('YoutubeEmbedLite',{staticClass:"p-about__video-item",attrs:{"vid":_vm.id,"thumb-quality":"hq","params":{start: 0}}})}
var staticRenderFns = []

export { render, staticRenderFns }